import PromotionBarPlugin from './plugin/promotion-bar/promotion-bar.plugin';
import AccessTokenIframePlugin from './plugin/access-token-iframe/access-token-iframe.plugin';

const PluginManager = window.PluginManager;
PluginManager.register('PromotionBarPlugin', PromotionBarPlugin, '[data-promotion-bar]');
PluginManager.register('AccessTokenIframePlugin', AccessTokenIframePlugin, '[data-access-token-iframe]');
